import React, { useState, useEffect, useRef } from "react";
import Layout from '../../components/Layout'
import { get, post, del } from '../../services/ApiService';
import "../custom-style.css";
import Loader from "../../components/Loader";
import Pagination from '../../components/Pagination';
import toast, { Toaster } from 'react-hot-toast';
import InquiryTable from "./InquiryTable";
import Breadcrumbs from "../../components/Breadcrumbs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";

const Inquiries = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [isNotFound, setNotFound] = useState(false); 
    const [inquiries, setInquiries] = useState([]); 
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setLimit] = useState(10);
    const [filters, setFilters] = useState({
        inquiryId: '',
        buyer: '',
        status: 'TO_ACTION',
        limit: '20',
    });
    useEffect(() => {
        fetchData()
    }, [currentPage, filters]);

    const fetchData = async () => {

        try {
            setIsLoading(true);
            const Body = {
              page: currentPage,
              ...filters,
              status: filters.status === 'TO_ACTION' ? 'TO_ACTION' : filters.status
            };
            const res = await post(`api/inquiries/list`, Body);
            console.log(res);
            if (res.success) {
              setIsLoading(false);
              setInquiries(res.inquiries);
              setTotalPages(res.totalPages);
              setNotFound(false);
            } else {
              setInquiries([]);
              setTotalPages(1);
              setIsLoading(false);
              setNotFound(true);
            }
        } catch (error) {
            setInquiries([]);
            setTotalPages(1);
            setIsLoading(false);
            setNotFound(true);
            console.error(error.message);
        }
    };


    const handleFilterChange = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value
        });
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleLimitChange = (event) => {
        setLimit(parseInt(event.target.value));
        setFilters({
            ...filters,
            [event.target.name]: event.target.value
        });
    };
    const resetFilters = () => {
        setFilters({
            inquiryId: '',
            buyer: '',
            status: 'All',
            limit: '20',
        });
        setCurrentPage(1); 
        setInquiries([]); 
        setTotalPages(1); 
    };


  return (
    <>
        <Layout>
            <Toaster 
                position="top-center"
                reverseOrder={false}
            />
            <div className="row mb-9 align-items-center justify-content-between">
                <div className="col-sm-6 mb-8 mb-sm-0">
                <h2 className="fs-4 mb-0">Cases</h2>
                <Breadcrumbs />
                </div>
                <div className="col-sm-6 col-md-3 d-flex flex-wrap justify-content-sm-end">
                    {/* <button className="btn btn-primary btn-sm">Hard Refresh</button> */}
                </div>
            </div>
            <div className="card mb-4 rounded-4 p-7">
                <div className="card-header bg-transparent px-0 pt-0 pb-7">
                <div className="row align-items-center justify-content-between mb-4">
                    <div className="col-lg-3 col-6  col-md-6 mr-auto mb-md-0 mb-6">
                        <input type="text" placeholder="Search by inquiry id..." name="inquiryId" value={filters.inquiryId} onChange={handleFilterChange}  className="form-control bg-input border-0" />
                    </div>
                    <div className="col-lg-3 col-6 col-md-6 mr-auto mb-md-0 mb-6">
                            <input type="text" placeholder="Search by buyer..." name="buyer" value={filters.buyer} onChange={handleFilterChange}  className="form-control bg-input border-0" />
                    </div>
                    <div className="col-lg-3 col-6 col-md-6 mr-auto mb-md-0 mb-6">
                    <select className="form-select" name="status" value={filters.status} onChange={handleFilterChange}>
                        <option value="All">All</option>
                        <option value="TO_ACTION">TO ACTION</option>
                        <option value="OPEN">OPEN</option>
                        <option value="WAITING_SELLER_RESPONSE">WAITING SELLER RESPONSE</option>
                        <option value="CLOSED">CLOSED</option>
                    </select>

                    </div>
                    <div className="col-lg-3 col-md-6 col-6 mr-auto mb-md-0 mb-6">
                            <select className="form-select" name="limit" value={filters.limit} onChange={handleLimitChange}>
                                <option value="10">Show 10</option>
                                <option value="20">Show 20</option>
                                <option value="50">Show 50</option>
                                <option value="100">Show 100</option>
                            </select>
                    </div>
                </div>
                </div>
                <div className="card-body px-0 pt-7 pb-0">
                    {isLoading  ? (
                        <div className="text-center">
                            <Loader />
                        </div>
                    ):(
                        <InquiryTable inquiries={inquiries} />
                    )}

                    {!isLoading && isNotFound && 
                        <div className="text-center">
                        <img src="/assets/images/no-data.png" style={{width:'60px',opacity:'0.5'}} />
                        <h6 style={{color:'#918f8f',fontFamily: 'math',fontWeight: '500'}}>No Data Found</h6>
                        </div>
                    }
                </div>
            </div>
            {totalPages && totalPages > 1 && 
                <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
            }
        </Layout>
    </>
  )
}

export default Inquiries